


















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import TabGroupRouted from "@/shared/components/ui/TabGroupRouted.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import CompanyDetailsForm from "../settings/CompanyDetailsForm.vue";
import PlanDetail from "../profile/PlanDetail.vue";
import Payroll from "../profile/Payroll.vue";
import { useUserStore } from "@/shared/store/user";
import SettingsNavigation from "@/employer/components/settings/SettingsNavigation.vue";

@Component ({
  components: {
      TabGroupRouted,
      Tab,
      CompanyDetailsForm,
      PlanDetail,
      Payroll,
      SettingsNavigation
    }
})

export default class PlanDetails extends Vue {
  userStore = useUserStore();
}

